import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

import userModule from "./modules/user.store";

const store = new Vuex.Store({
  modules: {
    user: userModule,
  },
  state: {
    navs: [],
    isLogin: false,
    visitId: "",
    prescription: "",
    patientId: "",
    // 继续就诊详情数据
    continueVisitDetail: {},
    pageInfo: {},
    patientImageId: "",
    // 检索数据
    easyData: {},
    currentMenuName: "",
    // 儿童体质辨识弹窗控制
    showChildrenDialog: false,
  },
  getters: {
    getVisitId: (state) => {
      return state.visitId;
    },
    getPatientId: (state) => {
      return state.patientId;
    },
    getContinueVisitDetail: (state) => {
      return state.continueVisitDetail;
    },
    pageInfo: (state) => {
      return state.pageInfo;
    },
    getPatientImageId: (state) => {
      return state.patientImageId
    },
    getEasyData: (state) => {
      return state.easyData
    },
    getCurrentMenuName: (state) => {
      return state.currentMenuName
    },
    getShowChildrenDialog: (state) => {
      return state.showChildrenDialog
    }
    
  },
  mutations: {
    setCurrentMenuName(state, val) {
      state.currentMenuName = val;
    },
    setVisitId(state, val) {
      state.visitId = val;
    },
    setPatientId(state, val) {
      state.patientId = val;
    },
    setContinueVisitDetail(state, val) {
      state.continueVisitDetail = val;
    },
    setPageInfo(state, val) {
      state.pageInfo = val;
    },
    setPatientImageId(state, val) {
      state.patientImageId = val;
    },
    setEasyData(state, val) {
      state.easyData = val;
    },
    setShowChildrenDialog(state, val) {
      state.showChildrenDialog = val;
    },
  },
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
    }),
  ],
});

export default store;
